import { render } from "./Linkage.vue?vue&type=template&id=3f8404b2&scoped=true"
import script from "./Linkage.vue?vue&type=script&lang=js"
export * from "./Linkage.vue?vue&type=script&lang=js"

import "./Linkage.vue?vue&type=style&index=0&id=3f8404b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8404b2"]])

export default __exports__